import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useReaderAuth } from "@/contexts/ReaderAuthContext";

export default function ReaderForgotPasswordPage() {
    const { forgotPassword } = useReaderAuth();
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const r = await forgotPassword(email);
            toast.success(r.message || "Email inviata");
            setSent(true);
        } catch (err) {
            toast.error(err.message || "Errore invio email");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-4 md:mt-10">
            <h1 className="pvx-serif text-3xl tracking-tight mb-2">Password dimenticata</h1>
            <p className="text-[13.5px] text-pvx-textmuted mb-8">
                Inserisci l'email con cui ti sei registrato. Ti invieremo un link per reimpostare la password.
            </p>

            {sent ? (
                <div className="pvx-card p-6 md:p-7 text-center" data-testid="forgot-success">
                    <Mail size={24} strokeWidth={1.5} className="mx-auto text-pvx-success mb-3" />
                    <div className="text-[14px] font-medium mb-1.5">Controlla la tua email</div>
                    <div className="text-[12.5px] text-pvx-textmuted mb-5">
                        Se l'indirizzo è registrato, riceverai un link entro pochi minuti.
                    </div>
                    <Link to="/reader/login" className="text-pvx-primary text-[13px] hover:underline">Torna al login</Link>
                </div>
            ) : (
                <form onSubmit={submit} className="pvx-card p-6 md:p-7 space-y-4" data-testid="reader-forgot-form">
                    <div>
                        <label className="pvx-eyebrow mb-1.5 block">Email</label>
                        <input
                            data-testid="forgot-email"
                            type="email" required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full h-10 px-3 rounded-[10px] border border-pvx-border bg-pvx-surface/60 focus:bg-pvx-surface focus:border-pvx-primary/50 text-[13.5px] outline-none transition-colors"
                            autoComplete="email"
                        />
                    </div>
                    <button
                        data-testid="forgot-submit"
                        type="submit"
                        disabled={busy}
                        className="w-full flex items-center justify-center gap-2 bg-pvx-primary text-white rounded-[10px] py-2.5 text-[13.5px] font-medium hover:opacity-90 disabled:opacity-60 transition-opacity"
                    >
                        {busy ? <Loader2 size={14} strokeWidth={1.5} className="animate-spin" /> : <Mail size={14} strokeWidth={1.5} />}
                        Invia link di recupero
                    </button>
                    <div className="pt-1 text-center text-[12.5px] text-pvx-textmuted">
                        <Link to="/reader/login" className="text-pvx-primary hover:underline">Torna al login</Link>
                    </div>
                </form>
            )}
        </div>
    );
}
